import React, { useState, useEffect, useContext } from "react";
import Goals from "onboarding/Goals/Goals";
import { Row, Col, Button, Container, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import allMetrics from "data/allMetrics.js";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import jsDig from "utils/jsDig";
import { RouterContext } from "../Onboarding";
import { isEmpty } from "lodash";

const allMetricData = allMetrics();

export default function SEOGoals(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();
  const metricList = allMetricData.metricsByDashboard.seo.metrics.goalsAndProjections;
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const today = new Date();
  const thisMonth = today.getMonth();
  const year = today.getFullYear();
  const dashboardsInit = [
    { name: "SEO: Overall", id: 0, goals: props.seo_section.goals },
    ...props.seo_section.landing_page_groups.map((group) => ({ name: group.name, id: group.id, goals: group.goals })),
  ];
  const [dashboards, setDashboards] = useState(dashboardsInit);
  const validationInit =
    jsDig(["goals", year, months[thisMonth]], dashboards[0]) &&
    (Object.values(jsDig(["goals", year, months[thisMonth]], dashboards[0])).includes("") ||
    Object.values(jsDig(["goals", year, months[thisMonth + 1]], dashboards[0])).includes("")
      ? false
      : true);
  const [validated, setValidatation] = useState(validationInit);
  useEffect(() => {
    let validationInit = true;
    if (!isEmpty(dashboards[0]["goals"][year])) {
      if (jsDig([0, "goals", year, months[thisMonth]], dashboards) && jsDig([0, "goals", year, months[thisMonth + 1]], dashboards)) {
        validationInit =
          Object.values(dashboards[0]["goals"][year][months[thisMonth]]).includes("") ||
          Object.values(dashboards[0]["goals"][year][months[thisMonth + 1]]).includes("")
            ? false
            : true;
      }
    }
    if (validationInit) setValidatation(true);
    else setValidatation(false);
  });
  return (
    <Container fluid className="px-md-3 px-0">
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className=" justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">SEO Goals</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              Let's set some goals for SEO. First, indicate which group and year you would like to set goals for. You can either set goals for all SEO, or
              choose by landing page group if you've already created and configured those. Then indicate which key metrics you would like to track. Lastly, you
              can set your goals by month in the fields below. You can autofill from previous years' metrics to set your goals to beat last years results.
            </p>
          </div>
        </Col>
      </Row>
      <Goals
        {...props}
        metricList={metricList}
        dashboards={dashboards}
        setDashboards={setDashboards}
        service="seo"
        onboarding
        submitForm={() => props.submitForm("/datapulse/onboarding/seo_goals")}
      />

      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`Goals must be filled out for this month AND next month`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
